module.exports = __webpack_public_path__ + "static/omega_g7-c97d188df262c1e46f704249f6ea5bac.jpg";